import React, { useEffect, useState } from "react";
import { Slider } from "antd";
import { PAGINATION_BASE_PARAMS } from "../../../hooks/useEngagementMaterialityScatter";

export const CompanyRangeSlider = ({
  totalCompanies,
  onRangeChange,
  isLoading,
}: {
  totalCompanies: number;
  isLoading: boolean;
  onRangeChange: (range: [number, number]) => void;
}): JSX.Element => {
  const [range, setRange] = useState<[number, number]>([
    0,
    Math.min(PAGINATION_BASE_PARAMS.page_size, totalCompanies),
  ]);

  useEffect(() => {
    setRange([0, Math.min(PAGINATION_BASE_PARAMS.page_size, totalCompanies)]);
    onRangeChange([
      0,
      Math.min(PAGINATION_BASE_PARAMS.page_size, totalCompanies),
    ]);
  }, [totalCompanies]);

  const updateRange = (newRange: [number, number]): void => {
    const MAX_GAP = PAGINATION_BASE_PARAMS.page_size;
    const [newStart, newEnd] = newRange;

    let adjustedStart = newStart;
    const adjustedEnd = newEnd;

    if (newEnd - newStart > MAX_GAP) {
      const gapOverflow = newEnd - newStart - MAX_GAP;
      adjustedStart = newEnd > range[1] ? newStart + gapOverflow : range[0];
    }

    const nextRange: [number, number] = [adjustedStart, adjustedEnd];

    onRangeChange(nextRange);
    setRange(nextRange);
  };

  return (
    <Slider
      step={1}
      disabled={isLoading || totalCompanies < 1}
      range
      min={0}
      max={totalCompanies}
      value={range}
      onChange={(val): void => updateRange(val as [number, number])}
      tooltip={{
        formatter: (v): string =>
          `Top ${v !== undefined ? v + 1 : 1} Companies`,
      }}
    />
  );
};
